import React, { useContext } from 'react';
import { urls } from '../..';
import { concatUrlPathnames, removeMultipleSlashes } from '../../data/sport-utils';
import { getLabel } from '../../data/labels';
import { isPrematchBasePath } from '../../common/seo/xrouter/seoUtils';
import { XRouterNavigateContext } from '../../common/seo/xrouter/XRouterNavigateContext';

export default function CalendarButton(props) {
    const xrouterNavigateContext =  useContext(XRouterNavigateContext);
    let urlCalendar;

    if(urls?.['calendar']?.startsWith(`${urls.prematch.base}`) && isPrematchBasePath(window.location.pathname)  ) {
        urlCalendar = urls?.['calendar'].replace(`${urls.prematch.base}/`,'')
    }else{
        urlCalendar =  urls?.['calendar'];
    }
    urlCalendar = removeMultipleSlashes(concatUrlPathnames(urls.basename,urlCalendar));
    
    return (
        <div className="relative h-sports-navbar-height min-w-sports-navbar-height overflow-x-auto mx-1 shrink-0 flex flex-col items-center justify-center" onClick={() => xrouterNavigateContext.navigate(urlCalendar,{state: {}})}>
            <div className="min-w-[60px] grid grid-cols-12 grid-rows-12 max-h-full leading-none items-center justify-items-center">
                <div className={"col-start-1 col-end-13 row-start-1 row-end-10 inline-flex items-center justify-center h-[24px] w-[24px]"}>
                    <i className="bi-calendar text-cs1" />
                </div>
                <div className="col-start-1 col-end-13 row-start-10 row-end-13 font-bold text-xxs text-cs1 uppercase truncate">{getLabel('menu.calendar')}</div>
            </div>
        </div>
    );
}
